module.exports = "<div class=\"s-progress-circle\">\r\n  <div conteiner *ngFor=\"let item of Skeleton.Items; let i = index\">\r\n    <div circule [ngClass]=\"(Skeleton.NumberProgress ==(i+1))? ' s-progress-circle-active ':''\">{{i+1}}</div>\r\n    <div line *ngIf=\"i<(Skeleton.Items.length-1)\"></div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/s-progress-circle/s-progress-circle.component.html
// module id = ./src/app/shared/components/s-progress-circle/s-progress-circle.component.html
// module chunks = main